import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';


@Component({
    selector: 'header-fullscreen',
    template: `
    <i nz-icon [nzType]="status ? 'fullscreen-exit' : 'fullscreen'"></i>
    {{ (status ? 'menu.fullscreen.exit' : 'menu.fullscreen') | translate }}
  `,
    // tslint:disable-next-line: no-host-metadata-property
    host: {
        '[class.d-block]': 'true',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderFullScreenComponent {
  status = false;
}
